export default {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Upsolve",
  url: "https://upsolve.org/",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://upsolve.org/search?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};
